var React = require('react');

function Follow (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(1 1)"},[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#FFF","strokeOpacity":".6","key":0}),React.createElement("g",{"strokeLinecap":"round","strokeLinejoin":"round","opacity":".7","transform":"translate(8 10)","key":1},[React.createElement("path",{"d":"M0 5.818S2.91 0 8 0s8 5.818 8 5.818-2.91 5.818-8 5.818-8-5.818-8-5.818z","key":0}),React.createElement("circle",{"cx":"8","cy":"5.818","r":"2.182","key":1})])]));
}

Follow.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34"};

module.exports = Follow;

Follow.default = Follow;
